import React, { useContext } from 'react';

import Skeleton from './Skeleton';
import { LayoutContext } from '../../context/layoutContext';
import { Flex } from '../../styles/globalStyles';

const render = ['onAirSkeleton1', 'onAirSkeleton2', 'onAirSkeleton3', 'onAirSkeleton4', 'onAirSkeleton5'];

const OnAirSkeleton = () => {
  const { matchese } = useContext(LayoutContext);
  return (
    <Flex justifyContent='space-between' style={{ padding: '24px 0' }}>
      {matchese ? (
        <div style={{ width: '100%' }}>
          <Skeleton type='text' width='80%' margin='25px 0' />

          <div style={{ padding: '10px 0' }}>
            <Skeleton type='text' width='30%' margin='15px 0' />
            <Skeleton type='text' width='60%' margin='5px 0' />
            <Skeleton type='text' margin='15px 0' />
            <Skeleton type='text' width='15%' margin='5px 0' />
          </div>

          <Skeleton type='text' width='80%' margin='25px 0' />
        </div>
      ) : (
        <>
          {render.map(item => (
            <div key={item} style={{ width: '100%', minHeight: '180px' }}>
              <Skeleton type='text' width='60%' margin='10px 0' />
              <Skeleton type='text' margin='20px 0' />
              <Skeleton type='text' width='30%' margin='10px 0' />
              <Skeleton type='text' width='15%' margin='10px 0' />
              <Skeleton type='text' width='60%' margin='10px 0' />
            </div>
          ))}
        </>
      )}
    </Flex>
  );
};

export default OnAirSkeleton;
